import { AnyAction, Dispatch, MiddlewareAPI } from "@reduxjs/toolkit"
import { RootState } from "../../store"
import { getItemWebStorage, setItemWebStorage } from "../../../features/webStorageSaver"

export const mapWaysideLandLotsMiddleware = (store: MiddlewareAPI<Dispatch<AnyAction>, RootState>) => (next: Dispatch<AnyAction>) => (action: AnyAction) => {
    const result = next(action)

    const actionsToWatch = [
        "mapWaysideLandLots/setMapFiltersState",
        "mapWaysideLandLots/patchMapFiltersState",
        "mapWaysideLandLots/resetAllMapFilters",
        "mapWaysideLandLots/resetSingleMapFilter",
        "mapWaysideLandLots/setAppliedFilters",
        "mapWaysideLandLots/setFilterMenuActiveTabs",
    ]

    if (actionsToWatch.includes(action.type)) {
        const state = store.getState()
        const filtersState = state.maps.waysideLandLots
        const { mapFiltersState, appliedFilters, filterMenuActiveTabs } = filtersState ?? {}

        // Получаем текущий mapsPreferences из хранилища
        const currentMapsPreferences = getItemWebStorage("mapsPreferences") ?? {}

        // Обновляем только ветку WaysideLandLots
        const updatedMapsPreferences = {
            ...currentMapsPreferences,
            WaysideLandLots: {
                mapFiltersState,
                appliedFilters,
                filterMenuActiveTabs,
            },
        }

        // Сохраняем обратно
        setItemWebStorage('mapsPreferences', updatedMapsPreferences)
    }

    return result
}
